import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import ConsumablesCalculatorAssayForm from './ConsumablesCalculatorAssayForm';
import FormToolbar from '../shared/FormToolbar';

const ConsumablesCalculatorAssayEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm toolbar={<FormToolbar />}>
      <ConsumablesCalculatorAssayForm {...props} />
    </SimpleForm>
  </Edit>
);

export default ConsumablesCalculatorAssayEdit;
